import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconPinterest = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <g clipPath={`url(#&{svgId})`}>
          <path
            d="M2 9.99991C2 13.2757 3.96987 16.0899 6.78867 17.3271C6.76617 16.7685 6.78467 16.0979 6.92792 15.4901C7.08173 14.8407 7.95729 11.131 7.95729 11.131C7.95729 11.131 7.70173 10.6202 7.70173 9.86529C7.70173 8.67976 8.38885 7.79434 9.2446 7.79434C9.97228 7.79434 10.3238 8.34089 10.3238 8.99537C10.3238 9.72685 9.85728 10.821 9.61734 11.8344C9.41691 12.683 10.0428 13.3752 10.88 13.3752C12.3958 13.3752 13.4166 11.4284 13.4166 9.12187C13.4166 7.36854 12.2357 6.0562 10.0878 6.0562C7.66104 6.0562 6.14923 7.8659 6.14923 9.88735C6.14923 10.5843 6.35473 11.0758 6.67661 11.4564C6.82461 11.6312 6.84517 11.7015 6.79161 11.9023C6.75323 12.0495 6.66511 12.4038 6.62861 12.5443C6.57536 12.7469 6.41117 12.8193 6.22805 12.7445C5.1103 12.2882 4.58974 11.0642 4.58974 9.68823C4.58974 7.41573 6.50636 4.6908 10.3073 4.6908C13.3617 4.6908 15.372 6.90099 15.372 9.27349C15.372 12.4117 13.6273 14.7562 11.0554 14.7562C10.1917 14.7562 9.37928 14.2894 9.10097 13.7591C9.10097 13.7591 8.63654 15.6023 8.53816 15.9582C8.36854 16.575 8.03654 17.1915 7.73298 17.6719C8.45247 17.8843 9.21253 18 10.0003 18C14.418 18 18 14.4183 18 9.99991C18 5.58171 14.418 2 10.0003 2C5.58211 2 2 5.58171 2 9.99991Z"
            fill="#CB1F27"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="16"
              height="16"
              transform="translate(2 2)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
